module.exports = __webpack_public_path__ + "c6ea6546ff4f539d1dff895914951047.png";